module.exports = __webpack_public_path__ + "static/media/userdetails.523dbdba.svg";